import axios from "axios";

//state
export var businessState = {
  businessAccounts: [],
  business: [],
  businessAccount: {},
  prueba: {},
  status_business: ""
};

//getters
export var businessGetters = {
  //funciones para optener informacion del state
  getBusinessAccounts: state => state.businessAccounts,
  getBusiness: state => state.business,
  getPrueba: state => state.prueba
};

//actions
export var businessActions = {
  async getBusinessAccounts({ commit,state }) {
    var access_token = state.api_token_facebook
    commit("business_request");
    await axios
      .get(`https://graph.facebook.com/v4.0/113799016686825/adaccounts`, {
        params: {
          fields: "name",
          access_token
        }
      })
      .then(res => {
        var businessAccounts = res.data.data;
        commit("business_success", businessAccounts);
        return res;
      })
      .catch(err => {
        commit("business_error");
        return err;
      });
  },
  async getBusiness({ commit }) {
    commit("business_request");
    await this._vm.$http
      .get("/apache/rest_api/apache.api", {
        headers: {
          //"X-Odoo-dbfilter": "apachev1",
          fields: '["name", "id","provider", "api_version", "user_id","business_id","access_token","app_secret","app_id"]'
        }
      })
      .then(res => {
        var business = res.data;
        commit("business_all_success", business);
        return res;
      })
      .catch(err => {
        commit("business_error");
        return err;
      });
  },
  async newBusiness({ commit, state }, business) {
    commit("business_request");
    var { name,provider,api_version,business_id,user_id,app_id,app_secret,access_token } = business;
    var formData = new FormData();
    var newBusiness = `{
      'provider':'${provider.value}',
      'name':'${name}',
      'api_version':'${api_version}',
      'business_id':'${business_id}',
      'user_id':'${user_id}',
      'app_id':'${app_id}',
      'app_secret':'${app_secret}',
      'access_token':'${access_token}',
    }`;
    formData.append("data", newBusiness);
    await this._vm.$http
      .post("/apache/rest_api/apache.api", formData, {
        headers: {
          "X-Odoo-dbfilter": "apachev1",
        }
      })
      .then(res => {
        if (res.status == 201) {
          business.id = res.data.id;
          business.provider = provider.value
          var business_all = state.business;
          business_all.push(business);
          commit("business_all_success", business_all);
          return business_all;
        } else {
          commit("business_error");
        }
      })
      .catch(err => {
        commit("business_error");
        return err;
      });
  },
  async editBusiness({ commit, state }, business) {
    commit("business_request");
    var { id,name,provider,api_version,business_id,user_id,app_id,app_secret,access_token } = business;
    var formData = new FormData();
    var newBusiness = `{
      'provider':'${provider.value}',
      'name':'${name}',
      'api_version':'${api_version}',
      'business_id':'${business_id}',
      'user_id':'${user_id}',
      'app_id':'${app_id}',
      'app_secret':'${app_secret}',
      'access_token':'${access_token}',
    }`;
    formData.append("data", newBusiness);
    await this._vm.$http
      .put("/apache/rest_api/apache.api", formData, {
        headers: {
          "X-Odoo-dbfilter": "apachev1",
        },
        params: {
          ids: `[${id}]`
        }
      })
      .then(res => {
        if (res.status == 200) {
          business.provider = provider.value
          var business_all = state.business;
          var index;
          for (var i = 0; i < business_all.length; i++) {
            if (business_all[i].id == id) {
              index = i;
              business_all[i] = business;
              break;
            }
          }
          business_all.splice(index, 1);
          business_all.splice(index, 0, business);
          commit("business_all_success", business_all);
          return business_all;
        } else {
          commit("business_error");
        }
      })
      .catch(err => {
        commit("business_error");
        return err;
      });
  },
  async deleteBusiness({ commit, state }, id) {
    commit("business_request");
    await axios
    .delete(`/apache/rest_api/apache.api/${id}`, { 
      headers: {
      "X-Odoo-dbfilter": "apachev1"
        }
      })
      .then(res => {
        if (res.status == 210) {
          var business = state.business;
          var index = business.findIndex(element => {
            return element.id == id;
          });
          business.splice(index, 1);
          commit("business_success", business);
          return business;
        } else {
          commit("business_error");
        }
      })
      .catch(err => {
        commit("business_error");
        return err;
      });
  },
  async deleteBusinessUtility({ commit, state }, id) {
    commit("business_request");
    var index;
    var business = state.business;
    for (var i = 0; i < business.length; i++) {
      if (business[i].id == id) {
        index = i;
        break;
      }
    }
    business.splice(index, 1);
    commit("business_success", business);
    return business;
  },
};

//mutations

export var businessMutations = {
  business_request(state) {
    state.status_business = "loading";
  },
  business_success(state, payload) {
    state.status_business = "success";
    state.businessAccounts = payload;
  },
  business_all_success(state, payload) {
    state.status_business = "success";
    state.business = payload;
  },
  business_error(state) {
    state.status_offert = "error";
  }
};
